import React, { createRef, useState, useEffect } from "react";
import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
  makeStyles,
} from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Page from "src/components/Page";
import MaterialTable from "material-table";

import { Alert, AlertTitle } from "@material-ui/lab";
import BudgetCodeSearchFormComponent from "src/components/forms/BudgetCodeSearchFormComponent";

import { priceNumberFormat } from "src/utils/Number";
import { hasRole } from "src/utils/Auth";
import {
  getBudgetAdjRemain,
  clearBudgetAdjRemain,
} from "src/redux/actions/budgetAdjustment.action";

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,

    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    overflow: "hidden",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const BudgetCodeSelectionComponent = () => {
  const classes = useStyles();
  const history = useHistory();
  const tableRef = createRef();
  const dispatch = useDispatch();

  const [selectedRow, setSelectedRow] = useState(null);
  const { authorizePR } = useSelector((state) => state.authorizationReducer);
  const { budgetAdjRemain } = useSelector(
    (state) => state.budgetAdjustmentReducer
  );

  useEffect(() => {
    dispatch(clearBudgetAdjRemain());
    return () => {};
  }, []);

  return (
    <Page className={classes.root} title="Budget Selection">
      <Container maxWidth={false}>
        <Box mb={2}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link
              color="inherit"
              onClick={() => {
                history.goBack();
              }}
            >
              Budget Adjustment
            </Link>

            <Link color="textPrimary" aria-current="page">
              Budget Selection
            </Link>
          </Breadcrumbs>
        </Box>
        <Box mb={2}>
          <Card>
            <CardHeader
              subheader="For budget adjustment on the system."
              title="Budget Selection"
            />
            <Divider />
            <CardContent>
              <BudgetCodeSearchFormComponent
                onSubmit={(value) => {
                  dispatch(getBudgetAdjRemain(value));
                }}
              />
            </CardContent>
          </Card>
        </Box>
        {selectedRow && (
          <Box mt={2} mb={2}>
            {selectedRow.BUDGETP_CODE == 0 ? (
              <Alert severity="info">
                <AlertTitle>Selection</AlertTitle>
                Row Selected — <strong>Budget Code : </strong>
                {selectedRow.ACC_CODE}, <strong>Budget Name : </strong>
                {selectedRow.ACC_NAME}
              </Alert>
            ) : (
              <Alert severity="info">
                <AlertTitle>Selection</AlertTitle>
                Row Selected — <strong>Budget Code : </strong>
                {selectedRow.ACC_CODE}, <strong>Budget Name : </strong>{" "}
                {selectedRow.ACC_NAME}, <strong>Project Code : </strong>{" "}
                {selectedRow.BUDGETP_CODE}
              </Alert>
            )}
          </Box>
        )}
        <Box mt={2} mb={2}>
          <Button
            disabled={Boolean(!selectedRow)}
            variant="contained"
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              history.push({
                pathname: `/create-budget-adjustment-requisition`,
                state: selectedRow,
              });
            }}
          >
            Budget Adjustment Form
          </Button>
        </Box>
        <MaterialTable
          title
          ref={tableRef}
          columns={[
            { title: "Code", field: "ACC_CODE" },
            { title: "Project Code", field: "BUDGETP_CODE" },
            { title: "Name", field: "ACC_NAME" },
            {
              title: "Brand",
              field: "BRAND_NAME",
            },
            {
              title: "Department",
              field: "DEPARTMENT_NAME",
            },
            {
              title: "Initial",
              field: "BUDGETSD_INITIAL",
              hidden: !Boolean(
                hasRole(authorizePR.data, [
                  "manager-budget-adjustment",
                  "super-admin",
                  "verifier-budget-adjustment",
                ])
              ),
              render: (rowData) => priceNumberFormat(rowData.BUDGETSD_INITIAL),
            },
            {
              title: "Revised",
              field: "REVISE",
              hidden: !Boolean(
                hasRole(authorizePR.data, [
                  "manager-budget-adjustment",
                  "super-admin",
                  "verifier-budget-adjustment",
                ])
              ),
              render: (rowData) => priceNumberFormat(rowData.REVISE),
            },
            {
              title: "Remain",
              field: "REMAINING",
              hidden: !Boolean(
                hasRole(authorizePR.data, [
                  "manager-budget-adjustment",
                  "super-admin",
                  "verifier-budget-adjustment",
                ])
              ),
              render: (rowData) => priceNumberFormat(rowData.REMAINING),
            },
          ]}
          data={budgetAdjRemain.data}
          isLoading={budgetAdjRemain.isLoading}
          options={{
            filtering: true,
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow && selectedRow.tableData.id === rowData.tableData.id
                  ? "#EEE"
                  : "#FFF",
            }),
          }}
          onRowClick={(evt, selectedRow) => {
            setSelectedRow(selectedRow);
          }}
        />
      </Container>
    </Page>
  );
};

export default BudgetCodeSelectionComponent;
